<template>
  <div class="top">
    <div class="top_box">
      <div class="top_upbox">
        <div class="logobox">
          <img class="logo_img" src="../static/home/logo1.png" alt="" />
          <img class="logo2" src="../static/home/logo2.png" alt="" />
        </div>
        <div class="rightbox">
          <div class="tq">
            <iframe
              width="125"
              scrolling="no"
              height="36"
              frameborder="0"
              allowtransparency="true"
              src="https://i.tianqi.com?c=code&id=6&color=%23333333&icon=1&py=qianjiang1&site=12"
            ></iframe>
          </div>
          <div class="langbox">
            <div :class="lang == 1 ? 'langcode' : 'lang'" @click="langss(1)">
              中
            </div>
            <div :class="lang == 2 ? 'langcode' : 'lang'" @click="langss(2)">
              EN
            </div>
            <div :class="lang == 3 ? 'langcode' : 'lang'" @click="langss(3)">
              JP
            </div>
            <div :class="lang == 4 ? 'langcode' : 'lang'" @click="langss(4)">
              KN
            </div>
          </div>
        </div>
      </div>
      <div class="top_downbox">
        <div
          :class="p == index ? 'top_optioncode' : 'top_option'"
          v-for="(item, index) in list"
          :key="index"
          @click="nuv(index)"
        >
          <div class="top_cn">
            {{ item.label }}
          </div>
          <div class="top_en" v-if="lang == 1">
            {{ item.path }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/api/article";
export default {
  name: "top",
  props: {
    p: Number,
    required: true,
  },
  data() {
    return {
      lang: 1,
      list: [], //网络
      list2: [
        {
          cn: "首页",
          en: "HOME",
        },
        {
          cn: "关于我们",
          en: "ABOUT US",
        },
        {
          cn: "世界遗产",
          en: "heritage",
        },
        {
          cn: "陈列展览",
          en: "display",
        },
        {
          cn: "馆藏文物",
          en: "cultural",
        },
        {
          cn: "宣传教育",
          en: "publicity",
        },
        {
          cn: "新闻资讯",
          en: "News",
        },
        {
          cn: "服务中心",
          en: "service",
        },
        {
          cn: "学术研究",
          en: "Academic",
        },
      ],
    };
  },
  created() {
    this.lang = JSON.parse(localStorage.getItem("langs")) || 1;

    menuList({
      siteType: 1,
      lang: this.lang,
    })
      .then((res) => {
        //头部菜单
        this.list = res.data;
        localStorage.setItem("ids", JSON.stringify(this.list));
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    nuv(e) {
      if (e == 0) {
        if (this.$route.name == "home") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "home", query: { nums: 0 } });
        }
      }
      if (e == 1) {
        if (this.$route.name == "about") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "about", query: { nums: 0 } });
        }
      }
      if (e == 2) {
        if (this.$route.name == "heritage") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "heritage", query: { nums: 0 } });
        }
      }
      if (e == 3) {
        if (this.$route.name == "display") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "display", query: { nums: 0 } });
        }
      }
      if (e == 4) {
        if (this.$route.name == "cultural") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "cultural", query: { nums: 0 } });
        }
      }
      if (e == 5) {
        if (this.$route.name == "publicity") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "publicity", query: { nums: 0 } });
        }
      }
      if (e == 6) {
        if (this.$route.name == "news") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "news", query: { nums: 0 } });
        }
      }
      if (e == 7) {
        if (this.$route.name == "online") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "online", query: { nums: 0 } });
        }
      }
      if (e == 8) {
        if (this.$route.name == "academic") {
          this.$router.replace("/refresh");
        } else {
          this.$router.push({ name: "academic", query: { nums: 0 } });
        }
      }
    },

    //
    langss(e) {
      this.lang = e; //选择语言文字  第几个
      localStorage.setItem("langs", e);
      menuList({
        siteType: 1,
        lang: this.lang,
      })
        .then((res) => {
          //头部菜单
          var ids = res.data;
          localStorage.setItem("ids", JSON.stringify(ids));
          this.$router.go(0); //请求成功
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeDestroy() {
    //退出页面时间
  },
};
</script>
<style scoped lang="less">
.top {
  height: 167px;
  width: 1920px;
  background-image: url("../static/home/top.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
}
.top_box {
  width: 1440px;
  height: 167px;
  margin: auto;
}
.top_upbox {
  height: 78px;
  display: flex;
  justify-content: space-between;
}
.logobox {
  display: flex;
}
.logo_img {
  height: 49px;
  object-fit: cover;
  margin-top: 20px;
  margin-right: 20px;
}
.logo2 {
  height: 45px;
  object-fit: cover;
  margin-top: 20px;
}
.rightbox {
  display: flex;
}
.tq {
  margin-top: 25px;
}
.langbox {
  width: 135px;
  height: 31px;
  display: flex;
  justify-content: space-between;
  color: #fff;
  margin-top: 29px;
}
.lang {
  width: 28px;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  background-color: #333333;
  clip-path: polygon(
    0px 7px,
    14px 0px,
    100% 7px,
    100% calc(100% - 7px),
    14px 100%,
    0 calc(100% - 7px)
  );
}
.lang:hover {
  background-color: #795f36;
}
.langcode {
  width: 28px;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  background-color: #795f36;
  clip-path: polygon(
    0px 7px,
    14px 0px,
    100% 7px,
    100% calc(100% - 7px),
    14px 100%,
    0 calc(100% - 7px)
  );
}

.top_downbox {
  height: 76px;
  display: flex;
  justify-content: space-between;
}
.top_option {
  width: 139px;
  height: 76px;
  background-image: url("../static/home/option.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top_optioncode {
  width: 139px;
  height: 76px;
  background-image: url("../static/home/option.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #d3a55e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top_cn {
  font-size: 18px;
  text-transform: uppercase;
  overflow: hidden; //超出隐藏
  white-space: nowrap; //超出不换行
  text-overflow: ellipsis; //超出显示省略号
}
.top_en {
  font-size: 12px;
  text-transform: uppercase;
  overflow: hidden; //超出隐藏
  white-space: nowrap; //超出不换行
  text-overflow: ellipsis; //超出显示省略号
}
</style>
